import Clone from 'clone';
import store from '../store';

const moment = require('moment');

export default {
  getClassElapsedTime(value) {
    const delayClass = {
      class: ['success', 'info', 'warning', 'danger'],
      range: [40, 50, 90, 10000000]
    };
    for (let i = 0; i < delayClass.range.length; i += 1) {
      if (value > (i === 0 ? 0 : delayClass.range[i - 1])
        && value <= delayClass.range[i]
      ) {
        return delayClass.class[i];
      }
    }
    return false;
  },
  getProgressData(slice) {
    let variant = null;
    let dateAMEO = moment(slice.ameoDate, 'DD/MM/YYYY');
    if (!dateAMEO.isValid()) {
      dateAMEO = moment(slice.ameoDate, 'YYYY-MM-DD HH:mm');
    }

    let dateFrom = null;

    // If the "Completed date" date is defined, the delay is calculated with this date
    if (typeof slice.completeDate != 'undefined' && slice.completeDate != null) {
      dateFrom = moment(slice.completeDate, 'DD/MM/YYYY');
      if (!dateFrom.isValid()) {
        dateFrom = moment(slice.completeDate, 'YYYY-MM-DD HH:mm');
      }
    } else {
      dateFrom = moment(new Date(), 'DD/MM/YYYY');
    }

    let dayNumber = 0;

    // EB classic dayNumber if there is still TU Opened
    dayNumber = dateFrom.diff(dateAMEO, 'days');

    // progress color variant
    if (dayNumber < 15) {
      variant = 'success';
    } else if (dayNumber >= 15 && dayNumber < 30) {
      variant = 'warning';
    } else {
      variant = 'danger';
    }

    return {
      days: dayNumber,
      variant: variant,
    };
  },
  trancheUpdatePassFilter(trancheUpdate, filters) {
    // Handling optional filters
    const isFiltered = typeof filters !== 'undefined' && filters !== null;
    let isUserIdFiltered = false;
    if (isFiltered) {
      if (typeof filters.userId !== 'undefined' && filters.userId !== null) {
        isUserIdFiltered = true;
      }
    } else {
      return true;
    }
    if (isUserIdFiltered && trancheUpdate.agent !== null && typeof trancheUpdate.agent !== 'undefined') {
      return trancheUpdate.agent.id === filters.userId;
    }
    return false;
  },
  getAgentScores(trancheUpdates, statusOnGoing, statusClosed) {
    // console.log('ENUMSSS : ::: ', store);

    const status = store.getters.getEnums.status.trancheUpdate;
    // console.log('ENUMSSS : ::: ', enums, store);
    // if (trancheUpdates.length > 0) {
    // Status
    // .filter(s => s.value === 'STATUS_ON_GOING')[0].text;
    // filter(s => s.value === 'STATUS_CLOSED')[0].text;
    // Filter dates
    const monthOfTheYear = moment().month();
    const yearOnGoing = moment().year();
    const mondayOfWeek = moment('00:00', 'HH:mm').set('year', yearOnGoing).set('month', monthOfTheYear).set('day', 1);
    const firstDayMonth = moment('01 00:00', 'DD HH:mm').set('year', yearOnGoing).set('month', monthOfTheYear);
    const firstDayYear = moment('01-01 00:00', 'MM-DD HH:mm').set('year', yearOnGoing);

    // OverAll list
    const tU = Clone(trancheUpdates);
    // OverAll list
    const tUClosed = Clone(trancheUpdates);
    // Return scores
    return {
      // Score EC
      //EC: this.mapReduceScore(tU, [status.STATUS_ON_GOING, status.STATUS_ANOMALY]),
      EC: this.mapReduceScore(tU, [status.STATUS_ON_GOING]),
      // Score S
      // S: this.mapReduceScore(tUClosed, [status.STATUS_CLOSED, status.STATUS_STUCK], mondayOfWeek),
      S: this.mapReduceScore(tUClosed, [status.STATUS_CLOSED], mondayOfWeek),
      // Score M
      //M: this.mapReduceScore(tUClosed, [status.STATUS_CLOSED, status.STATUS_STUCK], firstDayMonth),
      M: this.mapReduceScore(tUClosed, [status.STATUS_CLOSED], firstDayMonth),
      // Score A
      A: this.mapReduceScore(tUClosed, [status.STATUS_CLOSED], firstDayYear),
    };
  },
  /* New Ebouin Code */
  mapReduceScore(list, statusList, dateMomentAfter) {
    const clonedList = Clone(list)
      .filter((t) => {
        // dateMomentAfter is optional
        if (typeof dateMomentAfter !== 'undefined' && dateMomentAfter !== null) {
          const dateIsAfterOrEqual = false;
          return statusList.indexOf(t.status) !== -1 && dateIsAfterOrEqual;
        }
        return statusList.indexOf(t.status) !== -1;
      });

      let trancheUpdatesWeight = 0;
      for (let i = 0; i < clonedList.length; i += 1) {
          const trancheUpdate = clonedList[i];
          trancheUpdatesWeight = trancheUpdatesWeight + trancheUpdate.weight;

          if(trancheUpdate.cbDec){
            trancheUpdatesWeight = trancheUpdatesWeight + 3;
          }
          if(trancheUpdate.cbCommand){
            trancheUpdatesWeight = trancheUpdatesWeight + 6;
          }
      }
      return trancheUpdatesWeight;

  },
  /* OLD - SReille code
  mapReduceScore(list, statusList, dateMomentAfter) {
    const clonedList = Clone(list)
      .filter((t) => {
        // dateMomentAfter is optional
        if (typeof dateMomentAfter !== 'undefined' && dateMomentAfter !== null) {
          const dateIsAfterOrEqual = moment(t.closedAt, 'YYYY-MM-DD HH:mm').isAfter(dateMomentAfter)
            || moment(t.closedAt, 'YYYY-MM-DD HH:mm').isSame(dateMomentAfter);
          return statusList.indexOf(t.status) !== -1 && dateIsAfterOrEqual;
        }
        return statusList.indexOf(t.status) !== -1;
      })
      .map(t => parseInt(t.weight));
    if (clonedList.length > 0) {
      return clonedList.reduce((a, b) => a + b);
    }
    return 0;
  },
   */
  getUserListWithScores(
    enedisCases,
    users,
    statusArchived,
    trancheStatusOngoing,
    trancheStatusClosed,
  ) {
    for (let i = 0; i < users.length; i += 1) {
      const user = users[i];
      const trancheUpdates = this.getFilteredTrancheUpdates(
        enedisCases,
        statusArchived,
        { userId: user.id },
      );
      user.scores = this.getAgentScores(trancheUpdates, trancheStatusOngoing, trancheStatusClosed);
    }
    return users;
  },
  trancheContainsGap(trancheToTest) {
    const tranche = Clone(trancheToTest);
    if (tranche.gapHistories.length > 0) {
      let lastGapHistory = tranche.gapHistories[0];
      if (tranche.gapHistories.length > 1) {
        lastGapHistory = tranche.gapHistories
          .sort((a, b) => {
            const isBefore = moment(a.updatedAt, 'YYYY-MM-DD HH:mm:ss').isBefore(moment(b.updatedAt, 'YYYY-MM-DD HH:mm:ss'));
            return isBefore ? 1 : -1;
          })[0];
      }
      return lastGapHistory.gaps.length > 0;
    }
    return false;
  },
  enedisCaseContainGaps(enedisCaseToTest) {
    const enedisCase = Clone(enedisCaseToTest);
    if (enedisCase.tranches.length > 0) {
      return enedisCase.tranches.filter(t => this.trancheContainsGap(t)).length > 0;
    }
    return false;
  },
  getLastGapHistoryOfTranche(tranche) {
    if (tranche.gapHistories.length > 0) {
      let lastGapHistory = tranche.gapHistories[0];
      if (tranche.gapHistories.length > 1) {
        lastGapHistory = tranche.gapHistories
          .sort((a, b) => {
            const isBefore = moment(a.updatedAt, 'YYYY-MM-DD HH:mm:ss').isBefore(moment(b.updatedAt, 'YYYY-MM-DD HH:mm:ss'));
            return isBefore ? 1 : -1;
          })[0];
      }
      return lastGapHistory;
    }
    return false;
  },
};



// WEBPACK FOOTER //
// ./src/services/TrancheService.js